import styled from 'styled-components';
import { Container } from 'styles';

export const Header = styled(Container).attrs({
  flex: true,
})`
  padding: 0 24px;
  width: 100%;
  border-bottom: 1px solid ${props => props.theme.colors.background.tertiary};
`;
